import styled from 'styled-components'
import type { PromotionalBannerProps } from '@velasca/types'

export const PromotionalBanner = styled.div<{
  variant: PromotionalBannerProps['variant']
}>`
  position: relative;
  padding: 1rem 0;
  background: ${({ theme, variant }) =>
    variant === 'semiTransparent'
      ? 'rgba(255, 255, 255, 0.3)'
      : theme.colors.primary};
  color: ${({ theme }) => theme.colors.background};
  transition: all 0.2s cubic-bezier(0, 0, 0, 1) 0s;
  z-index: 1;

  @media (min-width: 1200px) {
    background: ${({ theme, variant }) =>
      variant === 'semiTransparent'
        ? 'rgba(255, 255, 255, 0.3)'
        : theme.colors.primary}};
  }
`

const PromotionalMessage = styled.div`
  width: 100%;
  padding: 0 4.5rem;

  p {
    word-break: break-word;
    font-family: ${({ theme }) => theme.fonts.brand};
    font-weight: 300;
    text-align: center;
  }

  a {
    &:hover,
    &:link,
    &:visited,
    &:active {
      text-decoration: underline;
    }
  }

  p,
  a {
    color: ${({ theme }) => theme.colors.text.secondary};
    margin: 0;
    font-size: 1.5rem;
    line-height: 1.5;
  }
`

export const MobileMessage = styled(PromotionalMessage)`
  @media (min-width: 768px) {
    display: none;
  }
`

export const DesktopMessage = styled(PromotionalMessage)`
  display: none;

  @media (min-width: 768px) {
    display: block;
  }
`

export const CloseButton = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0.5rem;
`
